import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-align-top",
  "use": "icon-align-top-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-align-top\"><path d=\"M64 64h896v64H64z\" p-id=\"6919\" /><path d=\"M192 960V192h256v768z\" p-id=\"6920\" /><path d=\"M576 704V192h256v512z\" p-id=\"6921\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol